module.exports = __webpack_public_path__ + "static/goaisatsu-c5550c0760985857598260c89ec03e87.png";